import { render, staticRenderFns } from "./GameAuthentication.vue?vue&type=template&id=16a43a72&scoped=true&"
import script from "./GameAuthentication.vue?vue&type=script&lang=ts&"
export * from "./GameAuthentication.vue?vue&type=script&lang=ts&"
import style0 from "./GameAuthentication.vue?vue&type=style&index=0&id=16a43a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a43a72",
  null
  
)

export default component.exports